'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stageMessageOnStubbedThread = undefined;

var _reduxActions = require('redux-actions');

var _StubbedThreadHistoryActionTypes = require('../constants/StubbedThreadHistoryActionTypes');

var stageMessageOnStubbedThread = exports.stageMessageOnStubbedThread = (0, _reduxActions.createAction)(_StubbedThreadHistoryActionTypes.STAGE_MESSAGE_ON_STUBBED_THREAD, function (message) {
  return { message: message };
});